<template>
    <vx-expandable-card>
        <template v-slot:header>Description (optional)</template>
        <template v-slot:content>
            <vx-input
                v-model="data.description"
                size="lg"
                :rows="3"
                maxlength="2000"
                :disabled="!props.canEdit"
                data-test="description-input"
                :error="displayFirstError(validation.description.$errors)"
            />
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard, VxInput } from '@voxie/frontend-components';
import { maxLength } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { displayFirstError } from '~/utils/validation';
import type { TermFormData } from '~/services/adminTermsClient.types';

const props = defineProps<{
    canEdit: boolean;
}>();

const data = defineModel<TermFormData>({ required: true });

const validation = useVuelidate(
    {
        description: { maxLength: maxLength(2000) },
    },
    data
);
</script>
